<div class="bolide-loader-container">
  <div class="text-center text-white" aria-label="AI Campus Property Data Intelligence loading">
    <div class="aic-hero-orb-wrap bolide-loader-orb position-relative mx-auto mb-3">
      <div class="aic-hero-ring aic-hero-ring-outer position-absolute rounded-circle pe-none" aria-hidden="true"></div>
      <div class="aic-hero-ring aic-hero-ring-mid position-absolute rounded-circle pe-none" aria-hidden="true"></div>
      <div class="aic-hero-orb position-absolute rounded-circle d-flex align-items-center justify-content-center">
        <span class="aic-hero-orb-mark d-block"></span>
      </div>
    </div>

    <div class="spinner-border spinner-border-sm text-light mb-3" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>

    <p class="text-white-50 small fw-semibold text-uppercase mb-2">AI Campus</p>
    <h1 class="fs-3 fw-bold mb-2">Preparing your workspace</h1>
    <p class="text-white-50 small mb-0">Property Data Intelligence</p>
  </div>
</div>
